import { reducer, initialStateBase } from './newCollection';

export const TYPE = 'FAQ_CONTENT';

export const urls = {
    getFaq: category => `/api/faq-content/${category}`,
    getFaqV2: () => '/api/faq-content'
};

export default (state = initialStateBase, action) => {
    switch (action.type) {
        case `RECEIVE_FAQ_CONTENT_${TYPE}`:
        case `RESPONSE_POST_ELEMENT_${TYPE}`:
            return reducer(state, {
                ...action,
                data: {
                    data: action.data.data
                }
            }, TYPE);
        default:
            return reducer(state, action, TYPE);
    }
};
